export default "__VITE_ASSET__d4d115bc__"